import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import enhancedAnalytics from '../utils/enhancedAnalytics';

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever route changes
    enhancedAnalytics.trackPageView(location.pathname, document.title);
  }, [location]);

  return null; // This component doesn't render anything
}

export default RouteTracker; 